import { useEffect, useState } from 'react'
import { useRoutes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthStore } from '@/store/auth'
import { useAccessCodeStore } from '@/store/accessCode'
import { AccessCodeModal } from '@/components/auth/AccessCodeModal'
import { TrackingMiddleware } from '@/components/common/TrackingMiddleware'
import routes from '@/config/routes'

console.log('App.tsx: Module loaded');

function App() {
  const [showAccessCodeModal, setShowAccessCodeModal] = useState(false)
  const [isCheckingAccess, setIsCheckingAccess] = useState(true)
  const { isVerified, checkTokenValidity, checkProtectionStatus, clearAccessToken } = useAccessCodeStore()
  const { isAuthenticated } = useAuthStore()
  
  // ✅ 移到最前面，确保Hook顺序一致
  const routeElements = useRoutes(routes)

  console.log('App: Component initializing')
  
  useEffect(() => {
    const checkAccess = async () => {
      try {
        // 1. 首先检查后端是否启用了验证码保护
        const isEnabled = await checkProtectionStatus()
        
        if (!isEnabled) {
          // 如果禁用了，直接隐藏弹窗并继续
          setShowAccessCodeModal(false)
          return
        }

        // 2. 如果启用了保护，检查本地是否有有效的 token
        const token = localStorage.getItem('access-token')
        
        if (token) {
          const isValid = await checkTokenValidity()
          if (isValid) {
            setShowAccessCodeModal(false)
          } else {
            clearAccessToken()
            setShowAccessCodeModal(true)
          }
        } else {
          setShowAccessCodeModal(true)
        }
      } catch (error) {
        console.error('Error checking access:', error)
        // 出错时默认显示，确保安全
        setShowAccessCodeModal(true)
      } finally {
        setIsCheckingAccess(false)
      }
    }

    checkAccess()
  }, [])

  // 监听 isVerified 状态，当验证成功时关闭弹窗
  useEffect(() => {
    if (isVerified) {
      setShowAccessCodeModal(false)
    }
  }, [isVerified])

  if (isCheckingAccess) {
    return <div className="flex items-center justify-center h-screen">加载中...</div>
  }

  if (showAccessCodeModal) {
    return <AccessCodeModal />
  }

  try {
    console.log('App: Auth state', { isAuthenticated })
    
    return (
      <>
        <TrackingMiddleware />
        {routeElements}
        <Toaster />
      </>
    )
  } catch (error) {
    console.error('App: Error in component render', error)
    return <div>Error in App component: {error instanceof Error ? error.message : 'Unknown error'}</div>
  }
}

export default App;